/* tslint:disable */
/* eslint-disable */
/**
 * Melco Fusion APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FusionMelcoFusionModelsProductionFiles
 */
export interface FusionMelcoFusionModelsProductionFiles {
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsProductionFiles
     */
    view_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsProductionFiles
     */
    ofm?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsProductionFiles
     */
    dst?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FusionMelcoFusionModelsProductionFiles
     */
    exp?: string | null;
}

export function FusionMelcoFusionModelsProductionFilesFromJSON(json: any): FusionMelcoFusionModelsProductionFiles {
    return FusionMelcoFusionModelsProductionFilesFromJSONTyped(json, false);
}

export function FusionMelcoFusionModelsProductionFilesFromJSONTyped(json: any, ignoreDiscriminator: boolean): FusionMelcoFusionModelsProductionFiles {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'view_name': !exists(json, 'view_name') ? undefined : json['view_name'],
        'ofm': !exists(json, 'ofm') ? undefined : json['ofm'],
        'dst': !exists(json, 'dst') ? undefined : json['dst'],
        'exp': !exists(json, 'exp') ? undefined : json['exp'],
    };
}

export function FusionMelcoFusionModelsProductionFilesToJSON(value?: FusionMelcoFusionModelsProductionFiles | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'view_name': value.view_name,
        'ofm': value.ofm,
        'dst': value.dst,
        'exp': value.exp,
    };
}


